// ── Shared date utilities ─────────────────────────────────────────────────────

export const RECURRENCE_OPTIONS = [
  { value: 'daily',    label: 'Daily' },
  { value: 'weekly',   label: 'Weekly' },
  { value: 'biweekly', label: 'Bi-weekly' },
  { value: 'monthly',  label: 'Monthly' },
]

/** YYYY-MM-DD string for today */
export function todayYMD() {
  return new Date().toISOString().slice(0, 10)
}

/** HH:MM string for the current time */
export function nowTimeStr() {
  const d = new Date()
  return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0')
}

/** Convert a Date object to YYYY-MM-DD */
export function toYMD(date) {
  return date.toISOString().split('T')[0]
}

/**
 * Generate an array of YYYY-MM-DD start dates for a recurring schedule.
 * @param {string} startDate  YYYY-MM-DD
 * @param {'daily'|'weekly'|'biweekly'|'monthly'} frequency
 * @param {string} endDate    YYYY-MM-DD (inclusive)
 * @returns {string[]}
 */
export function generateRecurringDates(startDate, frequency, endDate) {
  const dates = []
  const end = new Date(endDate + 'T00:00:00')
  let cur  = new Date(startDate + 'T00:00:00')
  const stepDays = { daily: 1, weekly: 7, biweekly: 14, monthly: 0 }
  while (cur <= end) {
    dates.push(cur.toISOString().slice(0, 10))
    if (frequency === 'monthly') {
      cur = new Date(cur.getFullYear(), cur.getMonth() + 1, cur.getDate())
    } else {
      cur = new Date(cur.getTime() + stepDays[frequency] * 86400000)
    }
    if (dates.length > 365) break // safety cap
  }
  return dates
}
